import React from 'react';
import classNames from 'classnames';
import Icon from '@vtblife/uikit-icons';
import s from './badge.module.css';
export const Badge = ({ size = 'm', color, variant = 'solid', children, onClick, dataTest, icon, tag, iconPosition = 'start', }) => {
    const BadgeTag = tag || (onClick ? 'button' : 'span');
    return (React.createElement(BadgeTag, { "data-test": dataTest, "data-badge": true, onClick: onClick, className: classNames(s.container, s[size], s[color], s[variant], onClick && s.clickable) },
        icon && iconPosition === 'start' && (React.createElement("span", { className: classNames(s.icon, s.start, !children && s.only) },
            React.createElement(Icon, { name: icon, size: "s" }))),
        children,
        icon && iconPosition === 'end' && (React.createElement("span", { className: classNames(s.icon, s.end, !children && s.only) },
            React.createElement(Icon, { name: icon, size: "s" })))));
};
//# sourceMappingURL=badge.js.map